/**
 * Represents a selection in two level selector
 */
export default class TwoLevelSelection
{
    /**
     * @param firstLevel selected first level entity
     * @param secondLevel selected users (users in selected groups do not include in this parameter)
     */
    constructor(firstLevel, secondLevel)
    {
        this.firstLevel = firstLevel;
        this.secondLevel = secondLevel;
    }

    getFirstLevel()
    {
        return this.firstLevel;
    }

    getSecondLevel()
    {
        return this.secondLevel;
    }

    isEmpty()
    {
        return (this.firstLevel.length === 0) && (this.secondLevel.length === 0);
    }

    static emptySelection()
    {
        if (!TwoLevelSelection.EMPTY_SELECTION)
            TwoLevelSelection.EMPTY_SELECTION = new TwoLevelSelection([], []);
        return TwoLevelSelection.EMPTY_SELECTION;
    }
}

TwoLevelSelection.FIRST_LEVEL_INDEX = 0;
TwoLevelSelection.SECOND_LEVEL_INDEX = 1;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/two_level_selection.js